import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { loginWithEmail, signupWithEmail, resetPassword, user } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (user) navigate("/");
  }, [user, navigate]);

  const handleSubmit = async () => {
    try {
      setError("");
      setLoading(true);

      if (isSignup) {
        await signupWithEmail(email, password);
      } else {
        await loginWithEmail(email, password);
      }
    } catch (e) {
      setError(e.message.replace("Firebase:", ""));
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>{isSignup ? "Create Account" : "Login"}</h2>

        {error && <p className="error">{error}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

<div style={{ display: "flex", alignItems: "center" }}>
  <input
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={password}
    onChange={e => setPassword(e.target.value)}
    style={{ flex: 1 }}
  />

  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      marginLeft: "-29px",
      cursor: "pointer",
      opacity: 0.6,
      userSelect: "none",
    }}
  >
    {showPassword ? "🙈" : "👁️"}
  </span>
</div>
<p
  style={{
    textAlign: "right",
    fontSize: "13px",
    cursor: "pointer",
    color: "#7a3f18",
    marginTop: "6px",
  }}
  onClick={async () => {
    if (!email) {
      alert("Please enter your email first");
      return;
    }

    try {
      await resetPassword(email);
      alert("Password reset email sent");
    } catch (e) {
      alert(e.message.replace("Firebase:", ""));
    }
  }}
>
  Forgot password?
</p>


        <button onClick={handleSubmit} disabled={loading}>
          {loading
            ? "Please wait..."
            : isSignup
            ? "Sign Up"
            : "Login"}
        </button>

        <p className="switch">
          {isSignup ? "Already have an account?" : "New user?"}{" "}
          <span onClick={() => setIsSignup(!isSignup)}>
            {isSignup ? "Login" : "Create account"}
          </span>
        </p>
      </div>
    </div>
  );
}
